// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__TW0wj","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__399RZ"};